export default class LoyaltyOnSite {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-on-site");

    if (!this.$el) {
      return;
    }
  }
}
